<template>
  <!-- 筛选条件 -->
  <div class="menu_box screening_condition">
    <div class="px14 bold screening_header">筛选条件:</div>
    <div>
        <div class="screening_property flex_jc_sb" v-if="screenList.areaListShow.no">
        <span>{{screenList.areaListShow.name}}</span>
        <div class="img_clear" @click="close('areaListShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="screening_property flex_jc_sb" v-if="screenList.listShow.no">
        <span>{{screenList.listShow.name}}</span>
        <div class="img_clear" @click="close('listShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <div class="screening_property flex_jc_sb" v-if="screenList.infoTypeShow.no">
        <span>{{screenList.infoTypeShow.name}}</span>
        <div class="img_clear" @click="close('infoTypeShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="screening_property flex_jc_sb" v-if="screenList.tenderTypeShow.no">
        <span>{{screenList.tenderTypeShow.name}}</span>
        <div class="img_clear" @click="close('tenderTypeShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <!-- 工程类型 -->
      <div class="screening_property flex_jc_sb" v-if="screenList.engineerTypeShow.no">
        <span>{{screenList.engineerTypeShow.name}}</span>
        <div class="img_clear" @click="close('engineerTypeShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <!-- 发布时间 -->
      <div class="screening_property flex_jc_sb" v-if="screenList.creatTimeShow.no">
        <span>{{screenList.creatTimeShow.name}}</span>
        <div class="img_clear" @click="close('creatTimeShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="screening_property flex_jc_sb" v-if="screenList.projeCateShow.no">
        <span>{{screenList.projeCateShow.name}}</span>
        <div class="img_clear" @click="close('projeCateShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <!-- <div class="screening_property flex_jc_sb" v-if="screenList.priceListShow.no">
        <span>{{screenList.priceListShow.name}}</span>
        <div class="img_clear" @click="close('priceListShow')">
          <i class="el-icon-close"></i>
        </div>
      </div> -->

      <div class="screening_property flex_jc_sb" v-if="screenList.timeListShow.no">
        <span>{{screenList.timeListShow.name}}</span>
        <div class="img_clear" @click="close('timeListShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <div class="screening_property flex_jc_sb" v-if="screenList.tenderStatusShow.no">
        <span>{{screenList.tenderStatusShow.name}}</span>
        <div class="img_clear" @click="close('tenderStatusShow')">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <!-- <div class="screening_property flex_jc_sb" v-if="screenList.biddingMethodShow.no">
        <span>{{screenList.biddingMethodShow.name}}</span>
        <div class="img_clear" @click="close('biddingMethodShow')">
          <i class="el-icon-close"></i>
        </div>
      </div> -->
    </div>
    <div
      v-if="screenList.listShow.no ||
            screenList.tenderTypeShow.no ||
            screenList.engineerTypeShow.no ||
            screenList.creatTimeShow.no ||
            screenList.infoTypeShow.no ||
            screenList.priceListShow.no ||
            screenList.timeListShow.no ||
            screenList.tenderStatusShow.no ||
            screenList.qualificationWayShow.no ||
            screenList.areaListShow.no ||
            screenList.biddingMethodShow.no"
      class="close-all"
      @click="closeAll()"
    >清空筛选</div>
    <!-- <el-row>
      <el-col :span="2">
        <div class="px14 bold screening_header">筛选条件:</div>
      </el-col>
      <el-col :span="21">
        <div class="screening_property flex_jc_sb"  v-if="screenList.listShow.no">
          <span>{{screenList.listShow.name}}</span>
          <div class="img_clear"
               @click="close('listShow')"><i class="el-icon-close"></i></div>
        </div>

        <div class="screening_property flex_jc_sb"  v-if="screenList.tenderTypeShow.no">
          <span>{{screenList.tenderTypeShow.name}}</span>
          <div class="img_clear"
               @click="close('tenderTypeShow')"><i class="el-icon-close"></i></div>
        </div>

        <div class="screening_property flex_jc_sb"  v-if="screenList.priceListShow.no">
          <span>{{screenList.priceListShow.name}}</span>
          <div class="img_clear"
               @click="close('priceListShow')"><i class="el-icon-close"></i></div>
        </div>

        <div class="screening_property flex_jc_sb"  v-if="screenList.tenderStatusShow.no">
          <span>{{screenList.tenderStatusShow.name}}</span>
          <div class="img_clear"
               @click="close('tenderStatusShow')"><i class="el-icon-close"></i></div>
    </div>-->
    <!--<div class="screening_property flex_jc_sb"  v-if="screenList.fromType.name">-->
    <!--<span>{{screenList.fromType.name}}</span>-->
    <!--<div class="img_clear"-->
    <!--@click="close('fromType')"><i class="el-icon-close"></i></div>-->
    <!--</div>-->
    <!-- </el-col>
    </el-row>-->
  </div>
</template>

<script>
export default {
  name: 'Screen',
  components: {},
  data () {
    return {}
  },
  props: {
    screenList: {
      type: Object,
      required: true
    },
    jCheck: {
      type: Object
    }
  },
  methods: {
    close (typeName) {
      if (typeName === 'listShow') {
        this.screenList.listShow.no = ''
      } else if (typeName === 'tenderTypeShow') {
        return
        this.screenList.tenderTypeShow.no = ''
      } else if (typeName === 'infoTypeShow') {
        this.screenList.infoTypeShow.no = ''
      } else if (typeName === 'priceListShow') {
        this.screenList.priceListShow.no = ''
      } else if (typeName === 'tenderStatusShow') {
        this.screenList.tenderStatusShow.no = ''
      } else if (typeName === 'timeListShow') {
        this.screenList.timeListShow.no = ''
      } else if (typeName === 'qualificationWayShow') {
        this.screenList.qualificationWayShow.no = ''
      } else if (typeName === 'projeCateShow') {
        this.screenList.projeCateShow.no = ''
      } else if (typeName === 'OneprojeCateShow') {
        this.screenList.projeCateShow.no = ''
      } else if (typeName === 'TwoprojeCateShow') {
        this.screenList.projeCateShow.no = ''
      } else if (typeName === 'areaListShow') {
        this.screenList.areaListShow.no = ''
      } else if (typeName === 'biddingMethodShow') {
        this.screenList.biddingMethodShow.no = ''
      } else if (typeName === 'engineerTypeShow') {
        this.screenList.engineerTypeShow.no = ''
      } else if (typeName === 'creatTimeShow') {
        this.screenList.creatTimeShow.no = ''
      }
      this.$emit('close', this.screenList, typeName)
    },
    closeAll () {
      this.screenList.listShow.no = ''
      this.screenList.tenderTypeShow.no = ''
      this.screenList.engineerTypeShow.no = ''
      this.screenList.creatTimeShow.no = ''
      this.screenList.infoTypeShow.no = ''
      this.screenList.priceListShow.no = ''
      this.screenList.tenderStatusShow.no = ''
      this.screenList.timeListShow.no = ''
      this.screenList.qualificationWayShow.no = ''
      this.screenList.areaListShow.no = ''
      this.screenList.biddingMethodShow.no = ''
      this.$emit('closeAll')
    }
  },
  watch: {},
  created () {},
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.screening_header {
  width: 130px;
  text-align: center;
  font-size: 14px;
  height: 33px;
  line-height: 33px;
}
.screening_condition {
  background-color: #fff;
  border-top: 1px solid #e4e7ed;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  padding: 4px 0;
  display: flex;
  height: 34px;
  align-items: center;
  margin-top: 1px;
}
.screening_inner {
  padding: 5px;
  font-size: 14px;
  display: inline-block;
  background: #fff;
  color: #747474;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  margin-right: 5px;
}
.screening_property {
  height: 30px;
  line-height: 30px;
  padding: 0 13px;
  font-size: 14px;
  display: inline-block;
  background: #fff;
  color: #969696;
  background-color: #f5f7fa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-right: 10px;
  .img_clear {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin: 0 0 0 5px;
    cursor: pointer;
  }
}
.bold {
  font-weight: 400;
  color: #666666;
}
.close-all {
  font-size: 14px;
  color: #666666;
  cursor: pointer;
}
</style>
